export let arrayOfChampionInTeamComp = [];
export let arrayOfRolesOfAssignedChampions = [];